export const getProgramMutationRefreshOptions = () => ({
  refetchQueries: 'active' as const,
  awaitRefetchQueries: true,
});
